module.exports = __webpack_public_path__ + "static/media/des.be10b345.svg";